import { alertSuccess } from "../../utils/feedback";
import axiosInstance from "../../axios/index";
import { translate } from "../../utils/utils";

import {
  SET_ALL_QUIZZES,
  SELECT_QUIZZ,
  SET_ANSWERS,
  SET_INCOMPLETED_QUIZZES,
  SET_COMPLETED_QUIZZES,
  SET_FORWARDED_QUIZZES,
  RESET_QUIZ_DATA,
  DELETE_QUIZ,
  SET_REPORT_ID_QUIZZ,
  SET_RECOMMENDED_QUIZZES,
  SET_PENDING_RECOMMENDED_QUIZZES,
  SET_IDENTIFIER,
  SET_THREAT_QUIZZES,
  SET_PENDING_THREAT_QUIZZES,
  SET_QUIZZES_BY_CATEGORIE,
  SET_CATEGORIES,
  SET_CATEGORIES_ADD_QUIZZES,
} from "../types/quizzesTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { getOrganizationProfileById } from "./organizationProfileCreators";
// import { fetchAllNotifications } from "./notificationsActionCreator";

// import {useHistory} from "react-router-dom";

export const setAllQuizzes = (items, totalPages, sources, level) => ({
  type: SET_ALL_QUIZZES,
  payload: { items, totalPages, sources, level },
});

export const setIdentifier = (identifier) => ({
  type: SET_IDENTIFIER,
  payload: identifier,
});

export const selectQuizz = (item, associtatedUser, isAllowed) => ({
  type: SELECT_QUIZZ,
  payload: { item, associtatedUser, isAllowed },
});

export const setReportId = (id) => ({ type: SET_REPORT_ID_QUIZZ, payload: id });

export const forwardedQuizzes = (quizzess, level, sources, totalPages) => ({
  type: SET_FORWARDED_QUIZZES,
  payload: { quizzess, level, sources, totalPages },
});

export const setAnswers = (answers) => ({
  type: SET_ANSWERS,
  payload: answers,
});

export const setIncompletedQuizzes = (items, totalPages, sources, level) => ({
  type: SET_INCOMPLETED_QUIZZES,
  payload: { items, totalPages, sources, level },
});

export const setRecommendedQuizzes = (items, totalPages, sources, level) => ({
  type: SET_RECOMMENDED_QUIZZES,
  payload: { items, totalPages, sources, level },
});

export const setPendingRecommendedQuizzes = (items) => ({
  type: SET_PENDING_RECOMMENDED_QUIZZES,
  payload: items,
});

export const setcompletedQuizzes = (items, totalPages, sources, level) => ({
  type: SET_COMPLETED_QUIZZES,
  payload: { items, totalPages, sources, level },
});

export const setThreatQuizzes = (items, totalPages, sources, level) => ({
  type: SET_THREAT_QUIZZES,
  payload: { items, totalPages, sources, level },
});

export const setPendingThreatQuizzes = (items) => ({
  type: SET_PENDING_THREAT_QUIZZES,
  payload: items,
});

export const setQuizzesByCategory = (items, totalPages, sources, level) => ({
  type: SET_QUIZZES_BY_CATEGORIE,
  payload: { items, totalPages, sources, level },
});

export const setCategories = (categories) => ({
  type: SET_CATEGORIES,
  payload: categories,
});

export const setCategoriesForAddQuizzes = (categories) => ({
  type: SET_CATEGORIES_ADD_QUIZZES,
  payload: categories,
});

// const storedUser = localStorage.getItem("user");

export const resetQuizData = (items) => ({ type: RESET_QUIZ_DATA });

export const removeQuiz = (id) => ({ type: DELETE_QUIZ, payload: id });

export const getAllCategories = async (dispatch) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const orgaId = localStorage.getItem("orgaId");
  console.log("orga id : : : ", orgaId);
  if (user.account_type === "enterprise") {
    const res = await axiosInstance.get(
      `/model/quizzes_categories?orga_id=${orgaId}`
    );
    dispatch(setCategories(res.data.categories));
  } else if (user.account_type === "free") {
    const res = await axiosInstance.get("/model/quizzes_categories");
    dispatch(setCategories(res.data.categories));
  }
};

export const getCategoryForAddQuizzes = () => async (dispatch) => {
  console.log("condition");
  // if (JSON.parse(storedUser)?.role==="cytailor_admin") {
  try {
    const res = await axiosInstance.get(`/model/search_category`);
    // console.log(res)
    await dispatch(setCategoriesForAddQuizzes(res.data.categories));
  } catch (error) {
    dispatch(requestFailed(error?.response?.data));
  }
  // }else {
  //   alert("condition")
  //   return true
  // }
};

export const fetchQuizzesByCategory =
  (page, category, searchText, filter, level) => async (dispatch) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const orgaId = localStorage.getItem("orgaId");
      let url = `/model/quizzes?quiz_category=${category}&source=&page=${page}&search${
        searchText ? "=" + searchText : ""
      }&source${filter !== "all" ? "=" + filter : ""}&level${
        level !== "all" ? "=" + level : ""
      }`;

      // If user is enterprise, append orgaId to the URL
      if (user.account_type === "enterprise") {
        url = `/model/quizzes?orga_id=${orgaId}&quiz_category=${category}&source=&page=${page}&search${
          searchText ? "=" + searchText : ""
        }&source${filter !== "all" ? "=" + filter : ""}&level${
          level !== "all" ? "=" + level : ""
        }`;
      }

      if (
        (category === "completed_quizzes" ||
          category === "questionnaires_terminés") &&
        (user.account_type = "enterprise")
      ) {
        url = `/survey/previous_surveys?orga_id=${orgaId}&page=${page}&search${
          searchText ? "=" + searchText : ""
        }&source${filter !== "all" ? "=" + filter : ""}&level${
          level !== "all" ? "=" + level : ""
        }`;
      } else if (
        (category === "completed_quizzes" ||
          category === "questionnaires_terminés") &&
        (user.account_type = "free")
      ) {
        url = `/survey/previous_surveys?&page=${page}&search${
          searchText ? "=" + searchText : ""
        }&source${filter !== "all" ? "=" + filter : ""}&level${
          level !== "all" ? "=" + level : ""
        }`;
      }

      if (
        category === "forwarded_usecases" ||
        category === "cas_usage_transférées"
      ) {
        url = `/survey/forwarded_surveys?source${
          filter !== "all" ? "=" + filter : ""
        }&search${searchText ? "=" + searchText : ""}&level${
          level !== "all" ? "=" + level : ""
        }&page=${page}`;
      }

      const res = await axiosInstance.get(url);
      dispatch(
        setQuizzesByCategory(
          res.data?.quizzes || [],
          // res.data?.pending_quizzes,
          res.data?.total_pages || 0,
          res.data?.sources || [],
          res.data?.level || []
        )
      );
    } catch (error) {
      console.error("Error fetching quizzes:", error);
      dispatch(setQuizzesByCategory());
      dispatch(requestFailed(error?.response?.data));
    }
  };

export const fetchAllQuizzes = (
  page,
  searchText,
  filter,
  level,
  isAuth,
  orgaId,
  accountType
) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res = isAuth
        ? accountType === "enterprise"
          ? await axiosInstance.get(
              `/model/quizzes?orga_id=${orgaId}&page=${page}&search${
                searchText ? "=" + searchText : ""
              }&source${filter !== "all" ? "=" + filter : ""}&level${
                level !== "all" ? "=" + level : ""
              }`
            )
          : await axiosInstance.get(
              `/model/quizzes?page=${page}&search${
                searchText ? "=" + searchText : ""
              }&source${filter !== "all" ? "=" + filter : ""}&level${
                level !== "all" ? "=" + level : ""
              }`
            )
        : await axiosInstance.get("/model/quizzes_off");
      const items = res.data;
      dispatch(
        setAllQuizzes(
          items?.quizzes,
          items?.total_pages,
          items?.sources,
          items?.level
        )
      );
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fechRecommendedQuizzes = (
  page,
  searchText,
  filter,
  level,
  orgaId,
  accountType
) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res = await axiosInstance.get(
        `/model/recommended_quizzes?${
          accountType === "enterprise" ? "orga_id=" + orgaId + "&" : ""
        }page=${page}&search${searchText ? "=" + searchText : ""}&source${
          filter !== "all" ? "=" + filter : ""
        }&level${level !== "all" ? "=" + level : ""}`
      );

      dispatch(requestSucceeded());
      const items = res.data;

      dispatch(
        setRecommendedQuizzes(
          items?.recommended_quizzes,
          items?.total_pages,
          items?.sources,
          items?.level
        )
      );
      dispatch(
        setPendingRecommendedQuizzes(items?.recommended_pending_quizzes)
      );
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
export const fetchThreatQuizzes = (
  page,
  searchText,
  filter,
  level,
  orgaId,
  accountType
) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.get(
              `/model/threat_quizzes?orga_id=${orgaId}&page=${page}&search${
                searchText ? "=" + searchText : ""
              }&source${filter !== "all" ? "=" + filter : ""}&level${
                level !== "all" ? "=" + level : ""
              }`
            )
          : await axiosInstance.get(
              `/model/threat_quizzes?page=${page}&search${
                searchText ? "=" + searchText : ""
              }&source${filter !== "all" ? "=" + filter : ""}&level${
                level !== "all" ? "=" + level : ""
              }`
            );
      dispatch(requestSucceeded());
      const items = res.data;
      dispatch(
        setThreatQuizzes(
          items?.threat_quizzes,
          items?.total_pages,
          items?.sources,
          items?.level
        )
      );
      dispatch(setPendingThreatQuizzes(items?.threat_pending_quizzes));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchIncompletedQuizzes = (
  page,
  searchText,
  filter,
  level,
  orgaId,
  accountType
) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.get(
              `/survey/incomplete_surveys?orga_id=${orgaId}&page=${page}&search${
                searchText ? "=" + searchText : ""
              }&source${filter !== "all" ? "=" + filter : ""}&level${
                level !== "all" ? "=" + level : ""
              }`
            )
          : await axiosInstance.get(
              `/survey/incomplete_surveys?page=${page}&search${
                searchText ? "=" + searchText : ""
              }&source${filter !== "all" ? "=" + filter : ""}&level${
                level !== "all" ? "=" + level : ""
              }`
            );
      dispatch(requestSucceeded());
      const items = res.data;
      dispatch(
        setIncompletedQuizzes(
          items?.incomplete_quizzes,
          items?.total_pages,
          items?.sources,
          items?.level
        )
      );
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchCompletedQuizzes = (
  page,
  searchText,
  filter,
  level,
  orgaId,
  accountType
) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.get(
              `/survey/previous_surveys?orga_id=${orgaId}&page=${page}&search${
                searchText ? "=" + searchText : ""
              }&source${filter !== "all" ? "=" + filter : ""}&level${
                level !== "all" ? "=" + level : ""
              }`
            )
          : await axiosInstance.get(
              `/survey/previous_surveys?&page=${page}&search${
                searchText ? "=" + searchText : ""
              }&source${filter !== "all" ? "=" + filter : ""}&level${
                level !== "all" ? "=" + level : ""
              }`
            );
      dispatch(requestSucceeded());
      const items = res.data;
      dispatch(
        setcompletedQuizzes(
          items?.old_quizzes,
          items?.total_pages,
          items?.sources,
          items?.level
        )
      );
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchQuizById = (isAuth, id, orgaId, accountType) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res = isAuth
        ? accountType === "enterprise"
          ? await axiosInstance.get(`/model/quizzes/${id}?orga_id=${orgaId}`)
          : await axiosInstance.get(`/model/quizzes/${id}`)
        : await axiosInstance.get(`/model/quizzes_off/${id}`);
      const item = res.data;

      dispatch(
        selectQuizz(item?.one_quiz, item?.associated_user, item?.is_allowed)
      );
      // dispatch(fetchAllUseCase());
      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchIncompteteQuizById = (id, orgaId, accountType) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.get(
              `/survey/incomplete_surveys/${id}?orga_id=${orgaId}`
            )
          : await axiosInstance.get(`/survey/incomplete_surveys/${id}`);

      dispatch(requestSucceeded());
      const item = res.data;
      if (res) {
        dispatch(setAnswers(item?.inc_quiz?.answers));
        dispatch(
          selectQuizz(item?.inc_quiz, item?.associated_user, item?.is_allowed)
        );
      }
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchCompletedQuizById = (id, history, accountType, orgaId) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res = (accountType = "enterprise"
        ? await axiosInstance.get(
            `/survey/previous_surveys/${id}?orga_id=${orgaId}`
          )
        : await axiosInstance.get(`/survey/previous_surveys/${id}`));
      dispatch(requestSucceeded());
      const item = res?.data?.old_quizzes;
      const reportId = res?.data?.report_id;
      dispatch(setAnswers(item?.answers));
      dispatch(selectQuizz(Array.isArray(item) ? item[0] : item));
      dispatch(setReportId(reportId));
    } catch (error) {
      if (error?.response?.status === 301) {
        history.push("/");
      }
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchForwardedQuizzes = (page, searchText, filter, level) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res = await axiosInstance.get(
        `/survey/forwarded_surveys?source${
          filter !== "all" ? "=" + filter : ""
        }&search${searchText ? "=" + searchText : ""}&level${
          level !== "all" ? "=" + level : ""
        }&page=${page}`
      );
      dispatch(requestSucceeded());
      const items = res.data;
      dispatch(
        forwardedQuizzes(
          items?.forwarded_quizzes,
          items?.level,
          items?.sources,
          items?.total_pages
        )
      );
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestAddAnswersQuiz = (data, orgaId, accountType, history) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    const token = localStorage.getItem("token");

    try {
      const res = token
        ? accountType === "enterprise"
          ? await axiosInstance.put(
              `/survey/addanswers?orga_id=${orgaId}`,
              data
            )
          : await axiosInstance.put(`/survey/addanswers`, data)
        : await axiosInstance.put(`/survey/addanswers_off`, data);
      dispatch(setAnswers(data.answers));
      dispatch(setIdentifier(res?.data?.identifier));
      dispatch(requestSucceeded());
      if (res) {
        alertSuccess(res.data);
      }
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestForwardToAFriend = (
  {
    answers,
    identifier,
    is_completed,
    quiz_id,
    version,
    forwarded_usecases,
    forward_id,
    pourcentage,
  },
  orgaId,
  accountType
) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.put(`/survey/addanswers?orga_id=${orgaId}`, {
              answers,
              identifier,
              is_completed,
              quiz_id,
              version,
              pourcentage,
            })
          : await axiosInstance.put(`/survey/addanswers`, {
              answers,
              identifier,
              is_completed,
              quiz_id,
              version,
              pourcentage,
            });

      const uuid = res?.data?.identifier;
      const forward =
        accountType === "enterprise"
          ? await axiosInstance.post(
              `/survey/forward_to_user?orga_id=${orgaId}`,
              {
                identifier: uuid,
                forwarded_usecases: forwarded_usecases,
                forward_id: forward_id,
              }
            )
          : await axiosInstance.post(`/survey/forward_to_user`, {
              identifier: uuid,
              forwarded_usecases: forwarded_usecases,
              forward_id: forward_id,
            });

      dispatch(setAnswers(answers));
      dispatch(requestSucceeded());
      if (res && forward) {
        alertSuccess(res.data);
        alertSuccess(forward.data);
      }
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

// export const generateRiskProfile = (profileDetails,orgaId,accountType) => {
//   return async (dispatch) => {
//     if (profileDetails) {
//       dispatch(requestStarted("orga"));
//     }
//     try {
//       const res = accountType === "enterprise"
//         ? await axiosInstance.post(
//           `/scoring/generate_risk_profile?orga_id=${orgaId}`,
//           {
//             threat: profileDetails,
//             identifier: profileDetails,
//             quiz_id: profileDetails,
//           }
//         )
//         : await axiosInstance.post(`/scoring/generate_risk_profile`,
//           {
//             threat: profileDetails,
//             identifier: profileDetails,
//             quiz_id: profileDetails,
//           }
//         )

//       // localStorage.setItem("pending_quizzes", pendingQuizzes);

//       if (profileDetails) {
//         dispatch(requestSucceeded());
//       }
//     } catch (error) {
//       console.log({ error });
//       dispatch(requestFailed(error?.response?.data));
//     }
//   };
// };

// const checkTaskStatusInBackground = async (taskId, orgaId, dispatch,isAuth) => {
//   try {
//     let taskStatus = "pending";
//     let counter = 0;
//     const maxAttempts = 3;
//       while (taskStatus === "pending" && counter < maxAttempts && taskId && isAuth ) {
//         await new Promise((resolve) => setTimeout(resolve, 7000));
//
//         const response = orgaId
//         ? await axiosInstance.get(`/calculator/task_status/${taskId}?orga_id=${orgaId}`)
//         : await axiosInstance.get(`/calculator/task_status/${taskId}`)
//
//         taskStatus = response.data.task_status;
//         counter++;
//
//         if (taskStatus === "success") {
//           dispatch(fetchAllNotifications());
//           return;
//         }
//       }
//     } catch (error) {
//       console.error("Error caught:", error.message || error);
//       dispatch(requestFailed(error?.response?.data || error.message));
//     }
//   };

export const requestSubmitAnswersQuiz = (
  data,
  history,
  isAuth,
  orgaId,
  accountType
) => {
  const entreprise_id = localStorage.getItem("orgaId");
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    const token = localStorage.getItem("token");

    try {
      const res = token
        ? accountType === "enterprise"
          ? await axiosInstance.put(
              `/survey/addanswers?orga_id=${orgaId}`,
              data
            )
          : await axiosInstance.put(`/survey/addanswers`, data)
        : await axiosInstance.put(`/survey/addanswers_off`, data);
      if (isAuth) {
        const result = token
          ? await axiosInstance.post(`/calculator/?orga_id=${orgaId}`, {
              quiz_id: Number(data.quiz_id),
              user_id: data.user_id,
              entreprise_id,
              version: data.version,
              identifier: res?.data?.identifier,
            })
          : await axiosInstance.post(`/calculator/`, {
              quiz_id: Number(data.quiz_id),
              user_id: data.user_id,
              entreprise_id,
              version: data.version,
              identifier: res?.data?.identifier,
            });

        // accountType === "enterprise"
        // ? checkTaskStatusInBackground(result.data.background_task_id, orgaId, dispatch,isAuth)
        // : checkTaskStatusInBackground(result.data.background_task_id, null, dispatch,isAuth)

        setTimeout(() => {
          dispatch(requestSucceeded());
          dispatch(getOrganizationProfileById(orgaId));
          history.push(`/reports/${result.data?.report_uuid}`);
          if (res) {
            alertSuccess(res.data);
          }
        }, 500);
      } else {
        await axiosInstance.post(`/calculator_off/`, {
          quiz_id: Number(data.quiz_id),
          user_id: data.user_id,
          organization_id: entreprise_id,
          version: data.version,
          identifier: res?.data?.identifier,
        });
        dispatch(requestSucceeded());
        history.push("/quizzes");
        if (res) {
          alertSuccess(res.data);
        }
      }
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestAddQuizz = (
  data,
  history,
  accountType,
  accountId,
  newVersion
) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const dataTitle = data.title;
      const dataDescription = data.description;
      let dataCategory = data.category;
      if (data.category === "add_new" && data.add_new_category !== "") {
        dataCategory = data.add_new_category;
      }
      delete data.title;
      delete data.description;
      delete data.category;
      delete data.add_new_category;

      if (accountType === "enterprise") {
        data.related_account_id = accountId;
      }
      const res = await axiosInstance.post(`model/quizzes`, {
        ...data,
        [translate("title")]: dataTitle,
        [translate("description")]: dataDescription,
        [translate("category")]: dataCategory,
        icon_url: data.icon_url,
      });

      if (newVersion) {
        setTimeout(() => {
          history.push(`/make-quizz/${res.data.quiz_id}?update=true`);
          dispatch(requestSucceeded(res.data.message));
          alertSuccess(res.data);
        }, 3000);
      } else {
        history.push(`/make-quizz/${res.data.quiz_id}?update=true`);
        dispatch(requestSucceeded(res.data.message));
        alertSuccess(res.data);
      }
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestEditQuizz = (
  isAuth,

  data,
  id,
  accountId,
  accountType,
  orgaId,
  icon
) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));

    try {
      const dataTitle = data.title;
      const dataDescription = data.description;
      let dataCategory = data.category;

      delete data.title;
      delete data.description;
      delete data.category;

      const res = await axiosInstance.put(`model/quizzes/${id}`, {
        ...data,
        [translate("title")]: dataTitle,
        [translate("description")]: dataDescription,
        [translate("category")]: dataCategory,
        icon_url: icon,
        related_account_id: accountId,
      });
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(fetchQuizById(isAuth, id, orgaId, accountType));
      // dispatch(fetchAllQuizzes(1, null, "all", orgaId, accountType));
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestRemoveUseCaseFromQuizz = (id, useCases, useCaseId) => {
  const data = useCases.filter((el) => el !== useCaseId);
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res = await axiosInstance.put(`model/quizzes/${id}`, {
        usecases: data,
      });
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(fetchQuizById(id));
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestRemoveQuiz = (
  page,
  searchText,
  filter,
  level,
  isAuth,
  id,
  accountId,
  orgaId,
  category
) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res = await axiosInstance.delete(
        `model/quizzes/${id}?related_account_id=${accountId}`
      );
      dispatch(requestSucceeded());
      // dispatch(fechRecommendedQuizzes( page,
      //   searchText,
      //   filter,
      //   level,
      //   orgaId,
      //  "enterprise"))

      // const totalPages = useSelector(
      //     (state) => state.quizzes.totalPages
      // );
      //
      // if (totalPages>0){
      //   dispatch(fetchQuizzesByCategory(1, category,searchText,filter,level))
      // }
      // else {
      //   const history = useHistory();
      //   history.push(`/quizzes`);
      // }

      await dispatch(
        fetchQuizzesByCategory(1, category, searchText, filter, level)
      );

      if (res.data) {
        alertSuccess(res.data);
      }
      dispatch(removeQuiz(id));
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
export const requestRestartQuiz = (accountType, identifier, orgaId) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.post(`/survey/restart_quiz?orga_id=${orgaId}`, {
              identifier,
              restarted: true,
            })
          : await axiosInstance.post(`/survey/restart_quiz`, {
              identifier,
              restarted: true,
            });
      dispatch(requestSucceeded());
      return res.data.restarted;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      return false;
    }
  };
};
